import { render, staticRenderFns } from "./MoveGroupForm.vue?vue&type=template&id=6184fb8d&"
import script from "./MoveGroupForm.vue?vue&type=script&lang=js&"
export * from "./MoveGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports